import React from 'react';
import GalleryListItem from './GalleryListItem.js';
import DocumentMeta from 'react-document-meta';

function GalleryList(props) {
  let rows = [];
  props.items.forEach(function(item, i) {
    rows.push(<GalleryListItem key={i} item={item} />);
  });

  const meta = {
    title: "Benjamin Walker Furniture - Custom Work",
    description: "Selected custom works from Benjamin Walker",
    meta: {
      charset: 'utf-8',
      name: {
        keywords: props.items.map(i => i.title).join(', ')
      }
    }
  };

  return (
    <DocumentMeta {...meta}>
      <div className="gallery-list">
        {rows}
      </div>
    </DocumentMeta>
  );
}

export default GalleryList;
